import { useState } from "react";

import { SubscriptionPeriod } from "../../../types";
import PurchaseModalCards from "../PurchaseModalCards/PurchaseModalCards";

import style from "./PurchaseModalContent.module.css";

export const PurchaseModalContent: React.FC = () => {
  const [selectedPeriod, setSelectedPeriod] = useState(SubscriptionPeriod.Yearly);

  return (
    <div className={style.purchaseModalContent}>
      <PurchaseModalCards
        handleSubcriptionPeriodChange={setSelectedPeriod}
        selectedPeriod={selectedPeriod}
      ></PurchaseModalCards>
    </div>
  );
};
